import { useContactFieldSuggestions } from '@/api/queries/contactFieldSuggestions';
import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { EducationFormItem } from '../../contactSchema';
import { defaultFormValues, educationStatusEnum } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const STATUS_OPTIONS = [
  { value: '', label: '—' },
  ...educationStatusEnum.options
    .filter((v) => v !== '')
    .map((v) => ({ value: v, label: v[0].toUpperCase() + v.slice(1) })),
];

const empty = (): EducationFormItem => ({ institution: '' });

export const EducationSection = withForm({
  defaultValues: defaultFormValues,
  render: function EducationSection({ form }) {
    // Curated suggestions from contact.profile.educationInstitution / contact.profile.educationFaculty
    // counter tables; free text stays allowed. Same table feeds profile.educationInstitution.
    const institution = useContactFieldSuggestions('profile.educationInstitution');
    const faculty = useContactFieldSuggestions('profile.educationFaculty');
    return (
      <SectionCard
        title="Education"
        actions={<AddItemButton onClick={() => form.pushFieldValue('education', empty())} />}
      >
        <form.AppField name="education">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove education entry">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`education[${i}].institution`}>
                        {(f) => <f.TextField label="Institution" required suggestions={institution.suggestions} />}
                      </form.AppField>
                      <form.AppField name={`education[${i}].faculty`}>
                        {(f) => <f.TextField label="Faculty" suggestions={faculty.suggestions} />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`education[${i}].degree`}>
                        {(f) => <f.TextField label="Degree" />}
                      </form.AppField>
                      <form.AppField name={`education[${i}].field`}>
                        {(f) => <f.TextField label="Field of study" />}
                      </form.AppField>
                      <form.AppField name={`education[${i}].status`}>
                        {(f) => <f.Select label="Status" options={STATUS_OPTIONS} />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`education[${i}].startDate`}>
                        {(f) => <f.DatePicker label="Start date" />}
                      </form.AppField>
                      <form.AppField name={`education[${i}].endDate`}>
                        {(f) => <f.DatePicker label="End date" />}
                      </form.AppField>
                      <form.AppField name={`education[${i}].location`}>
                        {(f) => <f.TextField label="Location" />}
                      </form.AppField>
                    </div>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
